import {
  mdiClipboardPlusOutline,
  mdiContentDuplicate,
  mdiDelete,
  mdiEyeOff,
  mdiFileExport,
  mdiHistory,
  mdiPackageDown,
  mdiPackageUp,
  mdiRss,
} from "@mdi/js";
import i18n from "../translations/i18n";
import { useAuthUserStore } from "../stores/authUser";

class _DatabaseModel {
  static bottomNav = { mobile: ["card"], desktop: ["list"] };
  static cardComponent = "base-card-component";
  static editDialogComponent = null;
  static tabs = [];
  static show = false;
  static showSize = 6;
  static filter = false;
  static operations = false;
  static createNewObject = { object: {}, params: {} };

  static cardFields(object) {
    return {
      title: object.name,
    };
  }

  static persistence_options = {
    1: "filter.existence_levels.archived",
    2: "filter.existence_levels.all",
  };

  static translatedSelect(prop) {
    return this[prop].map((key) => ({
      value: key,
      text: i18n.t(`${this.model}.${prop}.${key}`),
    }));
  }

  static isModel(...models) {
    return models.includes(this.model);
  }

  static submenuActions = [];
  static archivedActions = [];

  static tableHeaders = [];
  static customSort = true;
  static customSorts() {
    return this.tableHeaders.filter((h) => h.sortable !== false);
  }

  static detailTab = {
    titleKey: "template.detail",
    component: "TemplatesDetailTab",
    disabled: this.defaultDisabledTab(),
  };

  static defaultDisabledTab() {
    return (object) =>
      !!object.discarded_at ||
      !!object.closed_at ||
      !object.permissions?.update;
  }

  static commonActions = {
    archive: {
      action: "archive",
      icon: mdiPackageDown,
      titleKey: "action.archive",
      disabled: (object) => !object.permissions?.destroy,
    },
    restore: {
      action: "restore",
      icon: mdiPackageUp,
      titleKey: "action.unarchive",
      disabled: (object) => !object.permissions?.destroy,
    },
    delete: {
      action: "delete",
      icon: mdiDelete,
      titleKey: "action.delete",
      disabled: (object) => !object.permissions?.destroy,
    },
    duplicate: {
      action: "duplicate",
      icon: mdiContentDuplicate,
      titleKey: "action.duplicate",
      disabled: (object) => !object.permissions?.duplicate,
    },
    createIssue: {
      action: "createIssue",
      icon: mdiClipboardPlusOutline,
      titleKey: "asset.label.submenu.new_issue",
    },
    manageSubscriptions: {
      action: "manageSubscriptions",
      icon: mdiRss,
      titleKey: "action.manage_subscription",
    },
    permittedPersons: {
      action: "permittedPersons",
      icon: mdiEyeOff,
      titleKey: "permission.label.permitted_persons",
      display: () => {
        const authUserStore = useAuthUserStore();
        return authUserStore.canSeeAppPartByUrl("roles");
      },
    },
    openActivities: {
      action: "openActivities",
      icon: mdiHistory,
      titleKey: "activity.activities",
      display: () => {
        const authUserStore = useAuthUserStore();
        return authUserStore.canSeeAppPartByUrl("activities");
      },
    },
    export: {
      action: "export",
      icon: mdiFileExport,
      titleKey: "action.export",
    },
  };
}

export default _DatabaseModel;
export { i18n };
